/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {ColDef} from 'ag-grid-community';
import {CommonHelperService} from '../service/common-helper.service';

export function isRowWriteAllowedByMetadata(colDef: ColDef | undefined, rowData: any): boolean {
    const field = String(colDef?.field || '').trim();
    if (!field) {
        return true;
    }
    const editorParams = colDef?.cellEditorParams as any;
    const controlField = String(editorParams?.writeControlField || '').trim();
    if (!controlField || !!editorParams?.writeAlwaysAllowed || !rowData) {
        return true;
    }
    const controlFieldValue = CommonHelperService.getDeepValue(rowData, controlField);
    const normalizedControlValue = String(controlFieldValue ?? '').trim().toLowerCase();
    if (!normalizedControlValue) {
        return true;
    }
    const allowedStates = Array.isArray(editorParams?.writeAllowedForAllFieldsWhenValueIn)
        ? editorParams.writeAllowedForAllFieldsWhenValueIn
        : [];
    return allowedStates.some((state: any) =>
        String(state ?? '').trim().toLowerCase() === normalizedControlValue);
}
